<template lang="pug">
  #program-stats
    span(v-if="activeGoal")
      | Your program is on its way {{ activeGoal.tooltip }}

      .program-progress
        Progress.level.progress.is-navy(
          :value="programData.totalSteps"
          :max="activeGoal.steps"
        )
        .level.is-marginless
          .level-left
          .level-right
            BTooltip(
              :label="`${activeGoal.steps.toLocaleString()} steps ${activeGoal.tooltip}`"
              position="is-left"
              type="is-dark"
              animated
            )
              | {{ activeGoal.title }}
              //- BIcon(:icon="activeGoal.icon")

        WtStatRow(
          icon="blue-shoe"
          name="Total Steps"
          :value="_.get(programData, 'totalSteps', '').toLocaleString()"
        )
        WtStatRow(
          icon="primary-participants"
          name="Participants"
          :value="_.get(programData, 'totalMembers', '').toLocaleString()"
        )
        WtStatRow(
          icon="purple-two-shoe"
          name="Daily Avg. Steps"
          :value="_.get(programData, 'averageSteps', '').toLocaleString()"
        )
</template>

<script>
import { mapGetters } from "vuex";
import WtTitle from "@@/WtTitle/WtTitle";
import WtStatRow from "@@/WtStatRow/WtStatRow";
import { dateUtilityMixin } from "@/mixins/dateUtilityMixin";
import analyticsTrackingMixin from "@/mixins/analyticsTrackingMixin";

export default {
  name: "ProgramStats",

  components: { WtStatRow, WtTitle },

  mixins: [dateUtilityMixin, analyticsTrackingMixin],

  props: {
    programData: {
      type: Object,
      default: null
    }
  },

  data() {
    return {
      goals: [
        {
          title: "North America",
          steps: 5946000,
          tooltip: "across North America!",
          icon: "earth"
        },
        {
          title: "Earth",
          steps: 65740092,
          tooltip: "around the Earth!",
          icon: "earth"
        },
        {
          title: "Moon",
          steps: 476000000,
          tooltip: "to the moon!",
          icon: "moon-waxing-crescent"
        },
        {
          title: "Mars",
          steps: 36200000000,
          tooltip: "to mars!",
          icon: "moon-full"
        }
      ]
    };
  },

  computed: {
    ...mapGetters("program", ["coreProgramMeta"]),

    activeGoal() {
      const steps = this.programData.totalSteps;
      const goal = this.goals.find(goal => goal.steps > steps);
      return goal || this.goals[this.goals.length - 1];
    },

    nextGoal() {
      return this.goals.find(goal => goal.steps > this.activeGoal.steps);
    }
  },
  mounted() {
    this.trackFeatureView("sitewide", "sitewide_program_stats");
  },

  methods: {
    dateFormat(startDate) {
      return this.date(startDate, "DATE_FORMAT_SLASH").formatted;
    }
  }
};
</script>

<style lang="sass" scoped>
#program-stats
  .progress
    margin-bottom: 0
  .program-progress
    margin: 2rem 0
</style>
